import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import { PipeModule } from '../../pipe/pipe.module';

@NgModule({
  declarations: [
    
  ],
  exports: [

  ],
  imports: [
    LazyLoadImageModule,
    PipeModule,  
    CommonModule
  ]
})
export class ModuloRedeSocialModule { }
